module.exports = __webpack_public_path__ + "static/media/DubaiW23-Bold.86f8a19b.woff";